import React from 'react';
import {AppBar, IconButton, Toolbar, Typography} from '@mui/material';
import BackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import logo from '../logo-trans.png';
import { useTranslation } from 'react-i18next';
import LanguageSelect from './LanguageSelect';
import Submenu from "./Submenu.jsx";

function MainNavbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const { t } = useTranslation();

  const brand = location.pathname.match(/^\/[a-z]{0,2}\/?$/) ? (
    <img alt="" src={logo} width="40" height="40" className="brand-logo" />
  ) : (
    <IconButton
      size="large"
      edge="start"
      color="inherit"
      aria-label="menu"
      onClick={() => navigate(`/${lang}`, { relative: false })}
    >
      <BackIcon className="back-icon" />
    </IconButton>
  );

  return <>
  <AppBar position="sticky" className="navbar">
    <Toolbar>
      {brand}
      <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'normal' }}>
        {t('core.progressingTogether')}
      </Typography>

      <LanguageSelect variant="primary" />
      <Submenu />
    </Toolbar>
  </AppBar>
  </>;
}
export default MainNavbar;
